import { render, staticRenderFns } from "./Gsbg.vue?vue&type=template&id=07e4a720&scoped=true&"
import script from "./Gsbg.vue?vue&type=script&lang=js&"
export * from "./Gsbg.vue?vue&type=script&lang=js&"
import style0 from "./Gsbg.vue?vue&type=style&index=0&id=07e4a720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4a720",
  null
  
)

export default component.exports